import moment from 'moment';
import CommonUtils from 'utilities/common-utils';
import { FilterType } from 'utilities/enum-utils';
import { BookingFilterAny } from './booking-filter';

/** @deprecated **/
export const defaultRosterFilters: BookingFilterAny[] = [
  { filter: 'sort', values: [['startDateTime', 'asc']] },
  {
    filter: FilterType.CUSTOMER,
    values: [],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.CUSTOMER).fullSelectionName,
  },

  {
    filter: FilterType.WORKER,
    values: [],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.WORKER).fullSelectionName,
  },
  {
    filter: FilterType.SHIFT_SLOT_STATUS,
    values: [],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.SHIFT_SLOT_STATUS).fullSelectionName,
  },
  {
    filter: FilterType.SERVICE,
    values: [],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.SERVICE_TYPE).fullSelectionName,
  },
  {
    filter: FilterType.SERVICE_TYPE,
    values: [],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.SERVICE_TYPE).fullSelectionName,
  },
  {
    filter: FilterType.SHOW_ARCHIVED_BOOKINGS,
    values: ['NO'],
    selectionLabel: CommonUtils.getFilterSettings(FilterType.SHOW_ARCHIVED_BOOKINGS).fullSelectionName,
  },
];

/** @deprecated **/
export const defaultRosterDateFilter: BookingFilterAny = {
  filter: FilterType.DATE_RANGE,
  values: [moment().startOf('isoWeek').toDate(), moment().endOf('isoWeek').toDate()],
  selectionLabel: CommonUtils.getFilterText(FilterType.DATE_RANGE, [
    moment().startOf('isoWeek'),
    moment().endOf('isoWeek'),
  ]),
};
